import { render, staticRenderFns } from "./addChainShop.vue?vue&type=template&id=3875989c&scoped=true&"
import script from "./addChainShop.vue?vue&type=script&lang=js&"
export * from "./addChainShop.vue?vue&type=script&lang=js&"
import style0 from "./addChainShop.vue?vue&type=style&index=0&id=3875989c&scoped=true&lang=css&"
import style1 from "./addChainShop.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3875989c",
  null
  
)

export default component.exports